// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"211":"3649896b4239e4d7","473":"584921ee6a84ebe3","499":"323a6b9afb9ab60e","880":"323a6b9afb9ab60e"}[chunkId] + ".js";
};